const CHUNK_LOAD_ERROR = /Loading chunk [\da-z\-_]+ failed/;
const RELOAD_TIMESTAMP_KEY = 'ChunkLoadError_ForceReload';
const ONE_HOUR = 1000 * 60 * 60;

const reloadedWithinLastHour = (): boolean => {
  const timestamp = sessionStorage.getItem(RELOAD_TIMESTAMP_KEY);
  return !!timestamp && Number(timestamp) > Date.now() - ONE_HOUR;
};

/**
 * If the error is a lazy-chunk load failure, force a single reload per hour (avoiding a reload loop)
 * and return true so the adapter skips reporting it. Client-only (uses window/sessionStorage).
 */
export const handleChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error) || !CHUNK_LOAD_ERROR.test(error.message) || reloadedWithinLastHour()) {
    return false;
  }
  sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, Date.now().toString());
  window.location.reload();
  return true;
};
